import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .bgW': {
        width: '285px',
        backgroundColor: '#fff',
    },
    '& .subtitle': {
        color: '#9B9B9B',
        fontSize: '12px',
    },
    '& .title': {
        color: '#005E96',
        fontSize: '16px',
    },
    '& .crtTitle': {
        color: '#005E96',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    '& .tableTool': {
        padding: '16px',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
        '& .searchWapper': {
            border: '1px solid #CCCCCC',
            borderRadius: '3px',
            width: '285px',
            height: '38px',
            '& .search': {
                height: '32px',
                color: '#58727C',
                padding: '0 10px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            border: '1px solid #CCCCCC',
        },
    },
    '& .tableWapper': {
        width: '100%',
        overflowX: 'auto',
        '& .table': {
            minWidth: '650px',
        }
    },
    '& .textWapper': {
        borderLeft: '1px solid #979797',
        marginLeft: '30px',
        padding: '0 13px',
        maxWidth: '150px',
        '& .title': {
            color: '#979797',
            fontSize: '12px',
        },
        '& .time': {
            marginTop: '15px',
            fontSize: '18px',
        },
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .btn': {
        width: '186px',
    },
    '& .m-20': {
        margin: '0 20px',
    },
    '& .wLong': {
        width: '346px !important',
    },
});